export const GALLERY_ENTITY_TYPES = {
  AD: 'ad',
  ASSET: 'asset',
} as const;

export const GALLERY_TABS = {
  ADS: 'ads',
  ASSETS: 'assets',
} as const;

export const GALLERY_ACTIONS = {
  DELETE: 'delete',
  DUPLICATE: 'duplicate',
  PREVIEW: 'preview',
  RENAME: 'rename',
  EDIT: 'edit',
  VIEW_DETAILS: 'view-details',
} as const;

export const AD_GALLERY_CREATE_FORMATS = {
  STANDARD_VIDEO: 'standard-video',
  AD_SELECTOR: 'ad-selector',
} as const;

export const NAVIGATION_DESTINATIONS = {
  CAMPAIGNS: 'campaigns',
  REPORTS: 'reports',
  AD_GALLERY: 'ad-gallery',
  CREATIVE_STUDIO: 'creative-studio',
  HELP_CENTER: 'help-center',
  CONTACT_US: 'contact-us',
  NOTIFICATIONS: 'notifications',
  USER_PROFILE: 'user-profile',
  SWITCH_ORGANIZATION: 'switch-organization',
  AD_ACCOUNT_SWITCH: 'ad-account-switch',
} as const;
